module.exports = __webpack_public_path__ + "img/logo-signal.aa2da9fb.svg";